import { css } from '@emotion/css';
import { theme } from '@repo-sapiens/theme';
import React from 'react';

export type PricingOption = 'monthly' | 'quarterly' | 'yearly';
type Props = {
  activeTab?: PricingOption;
  onSelect?: (tab: PricingOption) => void;
};
export const PricingTabs: React.FC<Props> = ({
  activeTab = 'monthly',
  onSelect,
}) => {
  return (
    <div
      className={css`
        border-radius: 16px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        width: 100%;
        overflow: hidden;
        border-radius: 8px;
border: 1px solid #38373E;
border-top-width: 1px;
border-bottom-width: 0.5px;
border-bottom-color: #38373e76;
border-left-color: #38373ebc;
box-shadow: 0 40px 40px -16px rgba(0, 0, 0, 0.50), 0 0 32px 0 rgba(57, 61, 68, 0.20);
padding: 6px;
      `}
    >
      <TabButton
        label="Monthly"
        active={activeTab === 'monthly'}
        onClick={() => onSelect?.('monthly')}
      />
      <TabButton
        label="Quarterly"
        tag="-20%"
        tagColor={theme.colors.accent['yellow/main']}
        active={activeTab === 'quarterly'}
        onClick={() => onSelect?.('quarterly')}
      />
      <TabButton
        label="Yearly"
        tag="-40%"
        tagColor={theme.colors.accent['green/main']}
        active={activeTab === 'yearly'}
        onClick={() => onSelect?.('yearly')}
      />
    </div>
  );
};

function TabButton({
  label,
  tag,
  tagColor,
  active,
  onClick,
}: {
  label: string;
  active?: boolean;
  tag?: string;
  tagColor?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}) {
  return (
    <button
      onClick={onClick}
      className={css`
        padding: 8px 16px;
        border: none;
        cursor: pointer;
        border-left: 1px solid #29282f;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 16px 8px;
        font-size: 21px;
        background: transparent;
        transition: background 0.2s ease-in-out;

        border-radius: 4px;
border: ${active ? '0.313px solid #3B3B3B' : 'none'};
background: ${active ? 'linear-gradient(180deg, #282828 0%, #1A1C1E 100%)' : 'transparent'};
box-shadow: ${active ? '0px 2.5px 2.5px 0px rgba(0, 0, 0, 0.25)' : 'none'};
      `}
    >
      {label}
      {tag && (
        <span
          className={css`
            background-color: ${tagColor || '#6a53fe'};
            color: ${theme.colors.text.dark};
            font-size: 12px;
            border-radius: 4px;
            padding: 2px 6px;
            margin-left: 8px;
          `}
        >
          {tag}
        </span>
      )}
    </button>
  );
}
